<template>
  <div>
    <CRow>
      <CCol md="12">
          <CCard>
            <CCardHeader>
              <CRow>
                <CCol col="6">
                  <strong>لیست مرخصی پرسنل</strong>

                </CCol>
                <CCol col="6">

                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol col="3">
                  <CSelect
                      :options="personnel_list"
                      :value.sync="selected_personnel"
                      color="secondary">
                    کارمند
                  </CSelect>
                </CCol>

                <CCol col="3">
                    <date-picker
                        type="year"
                        label="سال"
                        v-model="year"/>

                </CCol>
              </CRow>
              <CRow>
                <CCol col="3">
                  <date-picker
                      label="تاریخ مرخصی"
                      v-model="new_leave_date"
                  />
                </CCol>
                <CCol col="3">
                  <CButton
                      outlined
                      color="primary"
                      @click="send_data()"
                    >افزودن مرخصی</CButton>
                </CCol>

              </CRow>
              <CDataTable
                  :items="items_filtered"
                  :fields="fields"
                  @row-clicked="table_row_clicked"

                  :items-per-page="10"
                  hover
                  sorter
                  striped
                  border
                  column-filter
                  pagination
              >
                <template #row="{item,index}">
                  <td style="text-align: center">
                    <p >{{ index + 1 }}</p>
                  </td>
                </template>
                <template #date="{item}">
                  <td style="text-align: center">
                    <p >{{
                      new Date(item.date).toLocaleDateString("fa-IR")
                      }}</p>
                  </td>
                </template>


                <template #operation="{item}">
                  <td>
                    <!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
                    <!--                                   name="cilApplications"/>-->

<!--                    <CIcon @click.native="$router.push({path:'edit/'+item.id})" class=" mr-1 text-primary" name="cil-pencil"/>-->

                    <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                  </td>
                </template>


              </CDataTable>
            </CCardBody>

          </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'



export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,

      items: [],
      items_filtered: [],
      year: '',
      new_leave_date: '',
      selected_personnel: 0,

      personnel_list: [],

      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'user_name', label: "کارمند", _style: 'width:20%'},
        {key: 'date', label: "تاریخ مرخصی", _style: 'width:20%;'},
        {key: 'operation', label: "عملیات", _style: 'width:10%;'},
      ],
      collapseDuration: 0,

      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.year = moment().format('jYYYY')
    this.get_personnel()

    // this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'year': function () {
      if(this.personnel_list.length>0){
        this.get_lists();

      }
    },
    'selected_personnel': function () {
      this.filter_data();
    }
  },
  methods: {
    filter_data(){
      this.items_filtered = this.items.filter(x=>x.user_id==this.selected_personnel);

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    get_personnel() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('/get_personnels', formData, {}).then(function (response) {

        var content_data = response.data;
        self.personnel_list = [{label: 'انتخاب کارمند', value: 0}]
        // items = content_cats.orders;
        content_data.forEach(function (val) {
          self.personnel_list.push({label: val.first_name + " " + val.last_name, value: val.id})

        })
        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    send_data() {
      if(this.new_leave_date==''){

        return false
      }
      var self = this;
      const formData = new FormData();
      var url = "insert_leave_date";
      var its = [];

      // console.log("items",its);
      formData.append("date", this.new_leave_date);
      formData.append("user_id", this.selected_personnel);
      axios.post(url, formData, {}).then(function (response) {

        // var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(response);
        self.get_lists();
        self.new_leave_date=''
        // if (content_data.statusCode == 0) {
        //
        //
        // } else {
        //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        //
        // }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      formData.append('year', this.year);


      axios.post('/get_leaves',formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },

      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
          self.items = content_data.map((item, row_id) => {
            return {...item, row_id}
          });
self.items.forEach(function (val){
  val.user_name = self.personnel_list.filter(x=>x.value==val.user_id)[0].label ?? 'کاربر وجود ندارد'
})
self.filter_data();

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "delete_leave_date";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
